<template>
  <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="submit">
    <v-card class="group-management-modal__card" flat>
        <div class="group-management-modal__header">
          <v-icon color="primary" class="group-management-modal__header-icon">
            {{ isEdit ? 'mdi-pencil-outline' : 'mdi-domain-plus' }}
          </v-icon>
          <h2 class="group-management-modal__title">
            {{ isEdit ? 'Редактирование группы' : 'Новая группа управляющей компаний' }}
          </h2>
        </div>
        <v-card-text class="group-management-modal__body">
          <v-row>
            <v-col cols="12" class="group-management-modal__field-col">
              <v-text-field
                v-model.trim="form.name"
                label="Название"
                outlined
                dense
                flat
                hide-details
                prepend-inner-icon="mdi-tag-outline"
                class="group-management-modal__field"
                :rules="[() => !!form.name || 'Обязательное поле']"
              />
            </v-col>
            <v-col cols="12" class="group-management-modal__field-col">
              <v-text-field
                v-model.trim="form.address"
                label="Адрес"
                outlined
                dense
                flat
                hide-details
                prepend-inner-icon="mdi-map-marker-outline"
                class="group-management-modal__field"
                :rules="[() => !!form.address || 'Обязательное поле']"
              />
            </v-col>
            <v-col cols="12" class="group-management-modal__field-col">
              <v-text-field
                v-model.trim="form.contacts"
                label="Контакты"
                outlined
                dense
                flat
                hide-details
                prepend-inner-icon="mdi-phone-outline"
                class="group-management-modal__field"
                :rules="[() => !!form.contacts || 'Обязательное поле']"
              />
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="group-management-modal__actions">
          <v-btn
            color="primary"
            class="text-none"
            rounded
            :disabled="!valid"
            @click="submit"
          >
            <v-icon left>mdi-content-save-outline</v-icon>
            {{ isEdit ? 'Сохранить' : 'Добавить' }}
          </v-btn>
          <v-btn
            color="primary"
            outlined
            rounded
            class="text-none ml-2"
            @click="close"
          >
            <v-icon left>mdi-close</v-icon>
            Отмена
          </v-btn>
        </v-card-actions>
    </v-card>
  </v-form>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'NewGroupManagementModal',
  props: {
    active: {
      type: Boolean,
      required: true,
    },
    id: {
      type: [Number, String],
      default: null,
    },
    initialData: {
      type: Object,
      default: null,
    },
  },
  data () {
    return {
      valid: true,
      form: {
        name: '',
        address: '',
        contacts: '',
      },
    };
  },
  computed: {
    isEdit () {
      return this.id != null && this.id !== '';
    },
  },
  watch: {
    active: {
      handler (val) {
        if (val) {
          this.$nextTick(() => this.fillForm());
        }
      },
      immediate: true,
    },
    initialData: {
      handler (val) {
        if (this.active && val) {
          this.fillForm();
        }
      },
      deep: true,
    },
  },
  mounted () {
    if (this.active && this.initialData) {
      this.fillForm();
    }
  },
  methods: {
    ...mapActions({
      createManagementGroup: 'GroupManagementCompany/createManagementGroup',
      updateManagementGroup: 'GroupManagementCompany/updateManagementGroup',
    }),
    fillForm () {
      if (this.initialData && typeof this.initialData === 'object') {
        this.form = {
          name: this.initialData.name != null ? String(this.initialData.name).trim() : '',
          address: this.initialData.address != null ? String(this.initialData.address).trim() : '',
          contacts: this.initialData.contacts != null ? String(this.initialData.contacts).trim() : '',
        };
      } else {
        this.form = { name: '', address: '', contacts: '' };
      }
    },
    submit () {
      this.$refs.form.validate();
      this.$nextTick(() => {
        if (!this.valid) return;
        const payload = {
          name: this.form.name,
          address: this.form.address,
          contacts: this.form.contacts,
        };
        if (this.isEdit) {
          this.updateManagementGroup({ id: this.id, data: payload })
            .then(() => {
              this.$flash_success('Изменения успешно сохранены!');
              this.$emit('submit');
              this.close();
            })
            .catch(() => {
              this.$flash_warning('Ошибка при редактировании группы управляющей компании');
            });
        } else {
          this.createManagementGroup(payload)
            .then(() => {
              this.$flash_success('Группа успешно создана!');
              this.$emit('submit');
              this.close();
            })
            .catch(() => {
              this.$flash_warning('Ошибка при создании группы управляющей компании');
            });
        }
      });
    },
    close () {
      this.$emit('close');
      this.$emit('update:active', false);
    },
  },
};
</script>

<style lang="scss" scoped>
.group-management-modal__card {
  border-radius: 12px;
  overflow: hidden;
}

.group-management-modal__header {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 16px 20px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
}

.group-management-modal__header-icon {
  flex-shrink: 0;
}

.group-management-modal__title {
  font-size: 1.125rem;
  font-weight: 500;
  color: #37474f;
  margin: 0;
  letter-spacing: -0.01em;
}

.group-management-modal__body {
  padding: 20px;
}

.group-management-modal__field-col {
  padding-top: 8px;
}

.group-management-modal__field-col:first-child {
  padding-top: 0;
}

.group-management-modal__field ::v-deep .v-input__prepend-inner .v-icon {
  color: rgba(0, 0, 0, 0.5);
}

.group-management-modal__actions {
  padding: 16px 20px;
  border-top: 1px solid rgba(0, 0, 0, 0.08);
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}
</style>
